import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var MonetaryRangeClass;
function MonetaryRange() {
  if (MonetaryRangeClass === VOID) {
    class $ {
      constructor(min, max) {
        this.d8q_1 = min;
        this.e8q_1 = max;
      }
      equals(other) {
        if (!(other instanceof MonetaryRange()))
          return false;
        var tmp0_other_with_cast = other instanceof MonetaryRange() ? other : THROW_CCE();
        if (!(this.d8q_1 === tmp0_other_with_cast.d8q_1))
          return false;
        if (!(this.e8q_1 === tmp0_other_with_cast.e8q_1))
          return false;
        return true;
      }
      hashCode() {
        var result = imul(getStringHashCode('min'), 127) ^ getBigIntHashCode(this.d8q_1);
        result = result + (imul(getStringHashCode('max'), 127) ^ getBigIntHashCode(this.e8q_1)) | 0;
        return result;
      }
      toString() {
        return '@com.crowpay.MonetaryRange(' + 'min=' + this.d8q_1.toString() + ', ' + 'max=' + this.e8q_1.toString() + ')';
      }
    }
    initMetadataForClass($, 'MonetaryRange');
    MonetaryRangeClass = $;
  }
  return MonetaryRangeClass;
}
//region block: exports
export {
  MonetaryRange as MonetaryRange1i296pttqy20q,
};
//endregion

//# sourceMappingURL=annotations.mjs.map
